import type { CSSProperties, ReactNode } from "react";

interface DataTableCardProps {
  eyebrow?: string;
  title: string;
  description?: string;
  columns: string[];
  rows: Array<Array<ReactNode>>;
  footer?: ReactNode;
}

const shellStyle: CSSProperties = {
  borderRadius: "24px",
  padding: "24px",
  background: "linear-gradient(180deg, rgba(9, 14, 26, 0.92), rgba(7, 11, 21, 0.82))",
  border: "1px solid rgba(255,255,255,0.08)",
  boxShadow: "0 18px 42px rgba(3, 8, 20, 0.24)"
};

const tableStyle: CSSProperties = {
  width: "100%",
  borderCollapse: "collapse"
};

const cellStyle: CSSProperties = {
  textAlign: "left",
  padding: "13px 0",
  borderTop: "1px solid rgba(255,255,255,0.07)",
  verticalAlign: "top",
  color: "rgba(238, 244, 255, 0.9)",
  lineHeight: 1.5
};

export function DataTableCard({ eyebrow, title, description, columns, rows, footer }: DataTableCardProps) {
  return (
    <section style={shellStyle}>
      <div className="stack-md">
        <div className="stack-xs">
          {eyebrow ? <span className="card-eyebrow">{eyebrow}</span> : null}
          <h3 className="card-title">{title}</h3>
          {description ? <p className="card-copy">{description}</p> : null}
        </div>
        <div style={{ overflowX: "auto" }}>
          <table style={tableStyle}>
            <thead>
              <tr>
                {columns.map((column) => (
                  <th
                    key={column}
                    style={{
                      ...cellStyle,
                      borderTop: "none",
                      paddingTop: 0,
                      paddingBottom: "10px",
                      fontSize: "0.7rem",
                      textTransform: "uppercase",
                      letterSpacing: "0.12em",
                      color: "rgba(191, 207, 229, 0.66)"
                    }}
                  >
                    {column}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {rows.map((row, index) => (
                <tr key={`row-${index}`}>
                  {row.map((cell, cellIndex) => (
                    <td
                      key={`row-${index}-cell-${cellIndex}`}
                      style={{
                        ...cellStyle,
                        fontSize: cellIndex === 0 ? "0.96rem" : "0.9rem",
                        color: cellIndex === 0 ? "#f5f9ff" : "rgba(223, 232, 246, 0.82)",
                        paddingRight: cellIndex === row.length - 1 ? 0 : 18
                      }}
                    >
                      {cell}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {footer ? <div style={{ paddingTop: "14px", borderTop: "1px solid rgba(255,255,255,0.07)" }}>{footer}</div> : null}
      </div>
    </section>
  );
}
